<template>
  <div>
    <v-chart :options="hm" theme="ovilia-green" />
  </div>
</template>

<style>
/**
 * The default size is 600px×400px, for responsive charts
 * you may need to set percentage values as follows (also
 * don't forget to provide a size for the container).
 */
.echarts {
  width: 100%;
  height: 50vh !important;
}
</style>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar'

import theme from './theme.json'
ECharts.registerTheme('ovilia-green', theme)

export default {
  components: {
    'v-chart': ECharts,
  },
  props: {
    chartData: {
      type: Array,
      default: () => {
        return []
      },
    },
    hours: {
      type: Array,
      default: () => [],
    },
    days: {
      type: Array,
      default: () => [],
    },
    max: {
      type: Number,
      default: 0,
    },
    dataKey: {
      type: String,
      required: true,
    },
    chartTitle: {
      type: String,
      required: false,
    },
    chartSubTitle: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      hm: {
        tooltip: {
          position: 'top',
        },
        animation: true,
        grid: {
          height: '50%',
          top: '10%',
        },
        xAxis: {
          type: 'category',
          data: this.hours,
          splitArea: {
            show: true,
          },
        },
        yAxis: {
          type: 'category',
          data: this.days,
          splitArea: {
            show: true,
          },
        },
        visualMap: {
          min: 0,
          max: 0,
          calculable: true,
          orient: 'horizontal',
          left: 'center',
          bottom: '15%',
        },
        series: [
          {
            name: this.key,
            type: 'heatmap',
            data: this.chartData,

            label: {
              show: true,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      },
    }
  },
  watch: {
    chartData(d) {
      this.hm.series[0].data = d
    },
    days(d) {
      this.hm.yAxis.data = d
    },
    max(m) {
      this.hm.visualMap.max = m
    },
    dataKey(k) {
      this.hm.series[0].name = k
    },
  },
}
</script>
